/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitexttitle2Inputs */

const en_aitexttitle2 = /** @type {(inputs: Aitexttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate text`)
};

const de_aitexttitle2 = /** @type {(inputs: Aitexttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text generieren`)
};

/**
* | output |
* | --- |
* | "Generate text" |
*
* @param {Aitexttitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitexttitle2 = /** @type {((inputs?: Aitexttitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitexttitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitexttitle2(inputs)
	return de_aitexttitle2(inputs)
});
export { aitexttitle2 as "aiTextTitle" }